"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var detect_1 = require("./detect");
exports.detect = detect_1.detect;
var logger_1 = require("./logger");
exports.defaultLogger = logger_1.defaultLogger;
exports.toLogger = logger_1.toLogger;
var match_1 = require("./match");
exports.matches = match_1.matches;
var plugin_1 = require("./plugin");
exports.BasePlugin = plugin_1.BasePlugin;
var spy_factory_1 = require("./spy-factory");
exports.create = spy_factory_1.create;
var util_1 = require("./util");
exports.inferPath = util_1.inferPath;
exports.inferType = util_1.inferType;
var operators_1 = require("./operators");
var plugin_2 = require("./plugin");
exports.plugins = {
    CyclePlugin: plugin_2.CyclePlugin,
    DebugPlugin: plugin_2.DebugPlugin,
    DevToolsPlugin: plugin_2.DevToolsPlugin,
    GraphPlugin: plugin_2.GraphPlugin,
    LetPlugin: plugin_2.LetPlugin,
    LogPlugin: plugin_2.LogPlugin,
    PausePlugin: plugin_2.PausePlugin,
    SnapshotPlugin: plugin_2.SnapshotPlugin,
    StackTracePlugin: plugin_2.StackTracePlugin,
    StatsPlugin: plugin_2.StatsPlugin
};
exports.operators = {
    hide: operators_1.hide,
    tag: operators_1.tag
};
